module.exports = __webpack_public_path__ + "static/img/img_7.039b9824.jpg";